import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom'
import {Intent, PopoverInteractionKind, Position, Popover} from '@blueprintjs/core/lib/esm/index';
import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';

import toastr from "toastr";
import _ from 'lodash';
import {getJwt, getCurrentUserId} from '../../../services/authService';

import http from "../../../services/httpService";

import ReactGA from "react-ga";
import CancelProPlan from '../../modals/CancelProPlan';
import sizeMe from 'react-sizeme';

import Theme from "../../../components/common/MuiTheme";
import StripeReplacementModal from '../../modals/StripeReplacementModal';
import ChartLoader from '../../utils/chart-loader';

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class BillingSubscriptions extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            posts: [],
            totalPosts: '',
            totalPages: '',
            totalCampaigns: 0,
            total_subscribers: 0,
            selectedSource: '',
            push_subscribers: [],
            pageSize: 25,
            currentPage: 1,
            lastPage: false,
            lastPageSize: '',
            paging: '',
            selectedAdAccount: '',
            sortColumn: {
                path: "updated_at",
                order: "asc"
            },
            loader: false,
            selectedCampaignPerformance: 'MESSAGES',
            preview: '',
            forceTableRerender: false,
            rowHeights: [100, 100, 100, 100, 100],
            tableColumnsWidth: [],
            minTableWidth: 500,
            lastColumnWidth: '',
            cancelProPlanOverlayIsOpen: false,
            userId: '',
            projectId: '',
            stripeReplacementModal: false,

            //cancelPlanParameters
            cancellationPlanId: '',
            cancellationSubscriptionId: '',
            cancellationPlanDate: ''
        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }


    getPostsData = async () => {
        let projectId = await this.props.selectedSource;
        let user = await this.props.user;
        if (user && user.id && projectId) {
            try {
                // this.setState({loader: false})
                await this.setState({loader: true, user})
                const pageSize = await this.state.pageSize;
                let selectedSubType = await this.props.selectedSubType;
                let selectedSource = await this.props.selectedSource || '1160';
                // let selectedSource = '1160';

                const result = await http.get('api/user/' + user.id + '/project/' + projectId + '/customers/get_subscriptions_project?page=' + pageSize + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}});
                // await console.log('Evo ga rezultat za project subscriptions: ', result.data.subscriptions)
                const data = await result.data.subscriptions;

                await this.setState({
                    selectedSource,
                    // rowHeights,
                    posts: data,
                    // selectedSubType: selectedSubType.name,
                    totalPosts: data.length,
                    totalPages: data.length / pageSize,
                    // lastPage: (data.total_pages < 1) || (this.state.currentPage === data.total_pages) ? true : false,
                    // lastPageSize: ((data.total_sms_s % this.state.pageSize) === 0) ? data.total_sms_s === 0 ? 0 : this.state.pageSize :
                    //     ((data.total_sms_s % this.state.pageSize) < 0) ? data.total_sms_s : data.total_sms_s % this.state.pageSize,
                    // selectedSubTypeFinished: this.props.selectedSubType.name,
                    // selectedTypeFinished: this.props.selectedType.name,
                    loader: false
                })
                // this.state.lastPageSize : this.state.posts.length :
                // this.state.pageSize === this.state.posts.length ? this.state.pageSize : this.state.posts.length)
                if (!this.state.posts) {
                    this.setState({loader: false})
                }
                await this.setState({forceTableRerender: true})
                await this.setState({forceTableRerender: false})
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    // toastr.error("Something went wrong... Please refresh and try again.");
                    this.setState({loader: false, posts: [], rowHeights: []})
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }

    }

    async componentDidMount() {
        //  ReactGA.pageview(window.location.pathname + window.location.search);
        this.props.updateUserFromServer();

        let projectId = await this.props.selectedSource;
        let userId = getCurrentUserId();
        this.setState({projectId, userId})

        try {
            await this.getPostsData()
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }

        // this.getPreview();
    }


    async componentDidUpdate() {
        if (this.props.selectedSource && ((this.state.selectedSource.toString() !== this.props.selectedSource.toString()) || (this.props.user.id && !this.state.user) && (!this.state.posts || this.state.posts.length === 0))) {
            await this.setState({
                loader: true,
                selectedSource: this.props.selectedSource
            })
            await this.getPostsData();
        }
    }

    handlePageChange = async (number) => {
        let page = parseInt(number)
        if ((page !== 0) && (page !== this.state.lastPage)) {
            await this.setState({currentPage: page, loader: true});
            this.getPostsData()
        }
    };

    handleChangeCampaignsNumberPerPage = async (value) => {
        await this.setState({
            currentPage: 1,
            pageSize: value,
            lastPage: value > this.state.totalPosts ? true : this.state.lastPage,
            lastPageSize: value > this.state.totalPosts ? this.state.totalPosts : this.state.lastPageSize,
            loader: true
        })

        await this.getPostsData()
    }

    getPreview = async () => {
        if (!this.state.preview) {
            try {
                const add_account_token = 'EAAZAfK9tK44IBADVZBY4gjXJZBqKdAdCqQokgs5uVNiWm9PtZA7L1qvMF6w2qmNcZCPZAfTfZCCtoxhfW0N3KJZBeRkXLMCfpKuq3SNu3Ybvl9R7JSJU337WcOZB4ZCeO2RyZCLBsBN7j5iDk8GyF2FhUAlbI6C6obOPLB2rCekBNYeGQZDZD';
                const add_account_id = 'act_269773933645768';
                const campaign = await this.state.campaigns[0] || {};
                const link = 'https://nba.com';
                let object_story_spec = {
                    "page_id": 106911734110630,
                    "link_data": {
                        "call_to_action": {
                            "type": "USE_APP",
                            "value": {
                                "link": link
                            }
                        },
                        "description": "Ovde ide opis",
                        "link": link,
                        "message": "Probna Poruka",
                        "name": "Ovde ide ime",
                        "picture": link
                    }
                }
                // const adsetId = await campaign.adsets.data[0].id || '';
                // const result = await http.get('https://graph.facebook.com/v4.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative={"type":27, "object_id": 112886416838535}&post={"link":"https://nba.com", "message":"Lorem ipsum dolor sit amet","picture":"http://url.to/your/custom/image.jpg","name":"Facebook","caption":"www.facebook.com","description":"Lorem ipsum dolor sit amet"}')
                const result = await http.get(facebook_app_marketing_url + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                    '&ad_format=MOBILE_FEED_STANDARD&creative={"object_story_spec": {"page_id": "106911734110630", "link_data": { "call_to_action": {"type": "LEARN_MORE", "value": { "link": "https://nba.com" } },"description": "Ovde ide opis", "link": "https://nba.com", "message": "Probna Poruka","name": "Ovde ide ime", "picture": "https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__340.jpg" }}}')

                // Ad formats: DESKTOP_FEED_STANDARD, FACEBOOK_STORY_MOBILE, INSTAGRAM_EXPLORE_CONTEXTUAL, INSTAGRAM_EXPLORE_IMMERSIVE, INSTAGRAM_STANDARD, INSTAGRAM_STORY, INSTANT_ARTICLE_RECIRCULATION_AD, INSTANT_ARTICLE_STANDARD, INSTREAM_VIDEO_DESKTOP, INSTREAM_VIDEO_MOBILE, MESSENGER_MOBILE_INBOX_MEDIA, MESSENGER_MOBILE_STORY_MEDIA, MOBILE_BANNER, MOBILE_FEED_BASIC, MOBILE_FEED_STANDARD, MOBILE_FULLWIDTH, MOBILE_INTERSTITIAL, MOBILE_MEDIUM_RECTANGLE, MOBILE_NATIVE, RIGHT_COLUMN_STANDARD, SUGGESTED_VIDEO_DESKTOP, SUGGESTED_VIDEO_MOBILE, WATCH_FEED_MOBILE"
                // const result = await http.get('https://graph.facebook.com/v5.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative=[{"object_story_spec": "' + object_story_spec + '"}]')


                const iframe = await result.data.data[0].body;
                await this.setState({preview: iframe})
            } catch (e) {
                //console.log('error: ', e)
            }
        }

    }

    convertDate = (unix_timestamp) => {
// Create a new JavaScript Date object based on the timestamp
// multiplied by 1000 so that the argument is in milliseconds, not seconds.

        let miliseconds = unix_timestamp * 1000;

        let toLocal = new Date(miliseconds).toLocaleDateString("en-US");

        let objectDate = new Date(toLocal);
        let fullDate = objectDate.toString();

        let year = fullDate.substring(11, 15);
        let month = fullDate.substring(4, 7);
        let day = fullDate.substring(8, 10);

        // console.log('convertDate: ', day + '. ' + month + ' ' + year)

        return day + '. ' + month + ' ' + year

    }

    titleCase = (str) => {
        let splitStr = str.toLowerCase().split(' ');
        for (let i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
    }

    cancelPlanHandle = (item) => {
        // console.log('item: ', item)
        this.setState({
            cancellationPlanId: item.subscriptionItems[0].plan_id,
            cancellationSubscriptionId: item.id,
            cancelProPlanOverlayIsOpen: true,
            cancellationPlanDate: this.convertDate(item.currentTermEnd, 'date')
        })

    }
    cancelProPlanModalClose = () => {
        this.getPostsData();
        this.props.updateUserFromServer();
        this.setState({
            cancelProPlanOverlayIsOpen: false
        })
    }

    handleRowsPerPageChange = async (number) => {
        await this.setState({pageSize: number})
        this.getPostsData();
    };

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }

    getMuiTheme = () => createTheme(Theme)

    render() {
        const columns = [
            {
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        const freePlanCheck = item.subscriptionItems[0].plan_id.includes('free_plan');
                        const proPlanCheck = item.subscriptionItems[0].plan_id.includes('boost') || item.subscriptionItems[0].plan_id.includes('essentials') || item.subscriptionItems[0].plan_id.includes('tester') || item.subscriptionItems[0].plan_id.includes('starter') || item.subscriptionItems[0].plan_id.includes('martech');
                        return <div className='min-width-130'> {item.subscriptionItems[0].plan_id.includes('martech') ?
                            <button id='plan-button' onClick={() => this.props.history.push('/redeem-code')}
                                    className='blue'>Upgrade</button>
                            :
                            freePlanCheck ?
                                <button id='plan-button' onClick={() => this.props.history.push('/subscription-plans')}
                                        className='blue'>Upgrade</button>
                                :
                                proPlanCheck ?
                                    <button id='plan-button'
                                            onClick={() => this.props.history.push('/subscription-plans')}
                                            className='blue'>Change Plan</button>
                                    :
                                    ''
                        }
                        </div>
                    }
                }
            },
            {
                name: "id",
                label: "Plan",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        let planIdHandled = String(item.subscriptionItems[0].plan_id.replaceAll('_', ' '))
                        const yearly = item.subscriptionItems[0].plan_id.includes('yearly') ? 'yearly' : 'monthly'
                        const phoneCheck = item.subscriptionItems[0].plan_id.includes('phone_plan');
                        const freePlanCheck = item.subscriptionItems[0].plan_id.includes('free_plan');
                        const proPlan25Check = item.subscriptionItems[0].plan_id.includes('essentials');
                        const proPlan50Check = item.subscriptionItems[0].plan_id.includes('boost');

                        const martech1check = item.subscriptionItems[0].plan_id.includes('martech_ltd_1');
                        const martech2check = item.subscriptionItems[0].plan_id.includes('martech_ltd_2');
                        const martech3check = item.subscriptionItems[0].plan_id.includes('martech_ltd_3');

                        const viberCheck = item.subscriptionItems && item.subscriptionItems.length &&
                            item.subscriptionItems[0].plan_id && item.subscriptionItems[0].plan_id.includes('viber');
                        // item.plan.nickname && item.plan.nickname.includes('Viber');
                        return <div>{
                            phoneCheck ? 'Phone number' : freePlanCheck ? 'Forever Free' : proPlan25Check ? 'Essentials ' + yearly :
                                proPlan50Check ? 'Boost ' + yearly : martech1check ? 'Martech 1' : martech2check ? 'Martech 2' :
                                    martech3check ? 'Martech 3' : viberCheck ? 'Viber BM' :
                                        <span className='capitalize'>{planIdHandled}</span>}</div>
                    }
                }
            },
            {
                name: "object",
                label: "Description",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        const phoneCheck = item.subscriptionItems[0].plan_id.includes('phone_plan');
                        const freePlanCheck = item.subscriptionItems[0].plan_id.includes('free_plan');
                        const proPlan25Check = item.subscriptionItems[0].plan_id.includes('essentials');
                        const proPlan50Check = item.subscriptionItems[0].plan_id.includes('boost');
                        const testerCheck = item.subscriptionItems[0].plan_id.includes('tester');
                        const starterCheck = item.subscriptionItems[0].plan_id.includes('starter');


                        const martech1check = item.subscriptionItems[0].plan_id.includes('martech_ltd_1');
                        const martech2check = item.subscriptionItems[0].plan_id.includes('martech_ltd_2');
                        const martech3check = item.subscriptionItems[0].plan_id.includes('martech_ltd_3');

                        const regionACheck = item.subscriptionItems && item.subscriptionItems.length &&
                            item.subscriptionItems[0].plan_id && item.subscriptionItems[0].plan_id.includes('region_a');
                        const regionBCheck = item.subscriptionItems && item.subscriptionItems.length &&
                            item.subscriptionItems[0].plan_id && item.subscriptionItems[0].plan_id.includes('region_b');
                        // const regionACheck = item.plan.nickname && item.plan.nickname.includes('Region A');
                        // const regionBCheck = item.plan.nickname && item.plan.nickname.includes('Region B');
                        return <div>{phoneCheck ? item.metadata && item.metadata.phone ? item.metadata.phone : '' :
                            freePlanCheck ? 'Base Plan' : proPlan25Check ? 'Emitto Pro Plan' : testerCheck ? 'Subscription' :
                                starterCheck ? 'Subscription' :
                                    martech1check ? 'LTD' : martech2check ? 'LTD' : martech3check ? 'LTD' :
                                        proPlan50Check ? 'Fully Featured Plan' : regionACheck ? 'Region A' :
                                            regionBCheck ? 'Region B' : ''}</div>
                    }
                }
            },
            {
                name: "id",
                label: "Type",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div>{item.subscriptionItems[0].plan_id.includes('martech') ? 'Lifetime'
                            :
                            item.billingPeriodUnit === 'month' ? 'Monthly' : 'Yearly'}</div>
                        // item.plan.interval === 'month' ? 'Monthly' : 'Yearly'}</div>
                    }
                }
            },
            {
                name: "status",
                label: "Status",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return item.cancel_at_period_end ?
                            <div style={{color: item.status === 'active' ? '#00B255' : '#EF4848'}}>
                                {item.status === 'trialing' ? 'trial' : item.status === 'non_renewing' ? 'canceled' : item.status}<br/>
                                <span style={{color: 'orange'}}>auto-renew off</span>
                            </div>
                            :
                            <div style={{color: item.status === 'active' ? '#00B255' : '#EF4848'}}>
                                {item.status === 'trialing' ? 'trial' : item.status === 'non_renewing' ? 'canceled' : item.status}
                            </div>
                    }
                }
            },
            {
                name: "amount",
                label: "Price",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        let taxRate = item.default_tax_rates && item.default_tax_rates.length && item.default_tax_rates[0].percentage ? item.default_tax_rates[0].percentage / 100 : '';
                        let discount = item.discount && item.discount.coupon && item.discount.coupon.percent_off ? item.discount.coupon.percent_off / 100 : 0;
                        // let amount = item.plan.amount / 100
                        let amount = item.subscriptionItems[0].amount / 100;
                        let currency = item.currencyCode === 'USD' ? '$' : item.currencyCode === 'EUR' ? '€' : item.currencyCode;
                        return <div>{currency}{taxRate && !discount ? parseFloat((amount * taxRate) + amount).toFixed(2) :
                            taxRate && discount ? parseFloat(((amount - (amount * discount)) * taxRate) + amount - (amount * discount)).toFixed(2) :
                                discount ? parseFloat(amount - (amount * discount)).toFixed(2) : parseFloat(amount).toFixed(2)}</div>
                    }
                }
            },
            {
                name: "sent_at_timezone",
                label: "Billing period",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div className='min-width-130'>
                            {item.subscriptionItems[0].plan_id.includes('martech') ?
                                'Lifetime' :
                                item.currentTermStart === null && item.currentTermEnd === null ?
                                    '-' :
                                    (this.convertDate(item.currentTermStart, 'date') + ' - ' + this.convertDate(item.currentTermEnd, 'date'))
                            }
                        </div>
                    }
                }
            },
            {
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        const phoneCheck = item.subscriptionItems[0].plan_id.includes('phone_plan');
                        const viberCheck = item.subscriptionItems && item.subscriptionItems.length &&
                            item.subscriptionItems[0].plan_id && item.subscriptionItems[0].plan_id.includes('viber');
                        const alphaCheck = item.subscriptionItems && item.subscriptionItems.length &&
                            item.subscriptionItems[0].plan_id && item.subscriptionItems[0].plan_id.includes('alpha');
                        // item.plan.nickname && item.plan.nickname.includes('Viber');
                        return item.subscriptionItems[0].plan_id.includes('martech') ? '' :
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}

                                position={Position.LEFT_TOP}
                                minimal={true}
                            >
                                <span id="feed-edit" className="fas fa-ellipsis-v"></span>
                                <div className="project-info-popover padding-10">
                                    {
                                        viberCheck ?
                                            <a href={'mailto:viber@emitto.io'} style={{color: '#EF4848'}}>Request
                                                Pause</a>
                                            :
                                            alphaCheck ?
                                                <a href={'mailto:sms@emitto.io'} style={{color: '#EF4848'}}>Request
                                                    Pause</a>
                                                :
                                                (item.subscriptionItems[0].plan_id === 'free_plan') || phoneCheck ?
                                                    <a style={{
                                                        opacity: 0.5,
                                                        color: '#EF4848',
                                                        cursor: 'default'
                                                    }}>Cancel</a>
                                                    :
                                                    <a onClick={() => this.cancelPlanHandle(item)}
                                                       style={{color: '#EF4848'}}>Cancel</a>
                                    }
                                </div>
                            </Popover>
                    }
                }
            }
        ];

        const options = {
            serverSide: false,
            count: this.state.totalPosts,
            filterType: 'none',
            selectableRows: 'none',
            rowsPerPage: this.state.pageSize,
            viewColumns: false,
            download: false,
            print: false,
            search: false,
            filter: false,
            sort: false,
            onChangeRowsPerPage: (number) => this.handleRowsPerPageChange(number),
            page: this.state.currentPage - 1,
            rowsPerPageOptions: [25, 50, 100],
            textLabels: {
                body: {
                    noMatch: this.state.tableLoader ?
                        this.tableLoaderRenderer()
                        :
                        <React.Fragment>
                            There are no subscriptions to be displayed. <Link  to='/subscription-plans'>Choose a new plan</Link>
                        </React.Fragment>
                },
            },
            onTableChange: (action, tableState) => {
                // console.log(action, tableState);

                // a developer could react to change on an action basis or
                // examine the state as a whole and do whatever they want

                switch (action) {
                    case 'changePage':
                        this.handlePageChange(tableState.page + 1);
                        break;
                    case 'sort':
                        this.handleSortContacts(tableState.sortOrder)
                        break;
                    // default:
                    //     console.log('action not handled.');
                }
            }
        };
        return (
            <div className='add-funds-content-container'>
                <div className='white-wrapper'>
                    <h2><strong>Subscriptions</strong></h2>
                    {
                        this.state.loader ?
                            this.tableLoaderRenderer()
                            :
                            <MuiThemeProvider theme={this.getMuiTheme()}>
                                <MUIDataTable
                                    title={""}
                                    data={this.state.posts}
                                    columns={columns}
                                    options={options}
                                />
                            </MuiThemeProvider>
                    }
                </div>
                <CancelProPlan
                    showModal={this.state.cancelProPlanOverlayIsOpen}
                    handleClose={this.cancelProPlanModalClose}
                    // selectedSource={selectedSource}
                    sources={this.props.sources}
                    // feedsShared={feeds_shared}
                    maxWidth={500}
                    userId={this.state.userId}
                    projectId={this.state.projectId}
                    planId={'free_plan'}
                    cancellationPlanId={this.state.cancellationPlanId}
                    cancellationSubscriptionId={this.state.cancellationSubscriptionId}
                    cancellationPlanDate={this.state.cancellationPlanDate}
                />
                <StripeReplacementModal
                    showModal={this.state.stripeReplacementModal}
                    handleClose={() => this.setState({stripeReplacementModal: false})}
                    maxWidth={600}
                    history={this.props.history}
                    user={this.props.user}
                    updateUserFromServer={this.props.updateUserFromServer}
                />
                {/*{console.log('posts: ', this.state.posts)}*/}
            </div>
        )
    }
}

export default sizeMe()(BillingSubscriptions);